import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=5aa6891c&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileData.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./ProfileData.vue?vue&type=style&index=1&id=5aa6891c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa6891c",
  null
  
)

export default component.exports